// Single source of truth for the seller product/variant colour palette.
// Used by UploadCatalogue, AddProduct and EditProduct (previously duplicated &
// drifted across all three). Each entry: { name, code } where `code` is the hex
// stored on the variant as `colorCode` (and the display name as `color`).
//
// "Multicolor" has no single hex — it uses the sentinel code 'multicolor', which
// swatchStyle() renders as a rainbow gradient wherever a swatch is drawn.

export const MULTICOLOR = 'multicolor';

export const colorOptions = [
  // Base palette (pre-existing)
  { name: 'Black', code: '#000000' },
  { name: 'White', code: '#FFFFFF' },
  { name: 'Red', code: '#FF0000' },
  { name: 'Blue', code: '#0000FF' },
  { name: 'Green', code: '#008000' },
  { name: 'Yellow', code: '#FFFF00' },
  { name: 'Purple', code: '#800080' },
  { name: 'Orange', code: '#FFA500' },
  { name: 'Pink', code: '#FFC0CB' },
  { name: 'Brown', code: '#964B00' },
  { name: 'Gray', code: '#808080' },
  { name: 'Navy', code: '#000080' },
  { name: 'Maroon', code: '#800000' },
  { name: 'Olive', code: '#808000' },
  { name: 'Cyan', code: '#00FFFF' },
  { name: 'Magenta', code: '#FF00FF' },
  // Newly added (from the Zammer Changes doc — Change 5)
  { name: 'Mehendi', code: '#6B8E23' },
  { name: 'Sky Blue', code: '#87CEEB' },
  { name: 'Salmon', code: '#FA8072' },
  { name: 'Crimson', code: '#DC143C' },
  { name: 'Chiku', code: '#C19A6B' },
  { name: 'Cream', code: '#FFFDD0' },
  { name: 'Off White', code: '#F8F8F0' },
  { name: 'Mustard', code: '#D4A017' },
  { name: 'Peach', code: '#FFDAB9' },
  { name: 'Rust', code: '#B7410E' },
  { name: 'Lavender', code: '#E6E6FA' },
  { name: 'Pista', code: '#BFD8B8' },
  { name: 'Firozi', code: '#40E0D0' },
  { name: 'Teal', code: '#008080' },
  { name: 'Golden', code: '#D4AF37' },
  { name: 'Silver', code: '#C0C0C0' },
  { name: 'Multicolor', code: MULTICOLOR }
];

// Returns an inline style for a colour swatch. Multicolor renders as a rainbow
// so it never shows as a single flat block. Use anywhere a swatch is drawn.
export const swatchStyle = (code) => {
  if (code === MULTICOLOR) {
    return {
      backgroundImage:
        'conic-gradient(#ff0000, #ff9900, #ffee00, #33cc33, #0099ff, #6633ff, #ff33cc, #ff0000)'
    };
  }
  return { backgroundColor: code };
};

export default colorOptions;
